import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';
import { Partner } from '@chancenwerk/master-data-management/partner/entities/Partner.js';
import { DateTime } from 'luxon';

/**
 * @entity RAGFundingInformation
 */
@Entity()
export class RAGFundingInformation extends AdornisEntity {
  public static override _class = 'RAGFundingInformation';

  @Field(type => ID, {
    default: v => {
      return v ?? A.getGloballyUniqueID();
    },
  })
  public _id: Maybe<string>;

  @Field(type => ID)
  public ragPartnerShouldID: Maybe<string>;

  @DataLoadedField(type => Partner, ({ ragPartnerShouldID }) => ragPartnerShouldID)
  public ragPartnerShould: Maybe<Partner>;

  @Field(type => ID)
  public ragPartnerIsID: Maybe<string>;

  @DataLoadedField(type => Partner, ({ ragPartnerIsID }) => ragPartnerIsID)
  public ragPartnerIs: Maybe<Partner>;

  @Field(type => DateTime)
  public ragPartnerBeginsFunding: Maybe<DateTime>;

  @Field(type => DateTime)
  public ragPartnerFundingUntil: Maybe<DateTime>;

  static override resolveID(entity: RAGFundingInformation): string {
    return entity._id ?? A.getGloballyUniqueID();
  }

  public get active() {
    return !!(
      this.ragPartnerIsID &&
      this.ragPartnerBeginsFunding &&
      this.ragPartnerBeginsFunding.startOf('day') <= DateTime.now().startOf('day') &&
      (!this.ragPartnerFundingUntil || this.ragPartnerFundingUntil.startOf('day') >= DateTime.now().startOf('day'))
    );
  }

  /**
   * This field is only filled on request with the below subscription. Only used to keep track where the information comes from
   * This could be done as a resolved field, but this would produce to much overhead tho.
   */
  @Field(type => KPF)
  public kpf: Maybe<KPF>;
}
